/**
 * Routes that must stay reachable even when the shop has no active products —
 * a gift card holder still needs to be able to check their balance or register
 * a card while the store itself isn't selling anything.
 * @param {string|undefined|null} routeName Nuxt route name
 * @returns {boolean} true when this route should bypass the "store not live" redirect
 */
export function isOfflineExemptRoute (routeName) {
  return routeName === 'offline' || routeName === 'balance' || routeName === 'register'
}
